import Page from "../Common/Page";
import React from "react";
import {
  Table,
  Button,
  Space,
  Modal,
  Form,
  Row,
  Col,
  Radio,
  Select,
  Popconfirm,
  message,
} from "antd";
import { http } from "../Common/http";
import { AuthContext } from "../Auth/Auth";
import { Messages } from "../Common/ValidateMessages";
import { AuthorityButton } from "../Components/AuthorityButton";
import { CommonMasterSelect } from "../Components/CommonMasterSelect";
import { JudgmentUnitSelecter } from "../Components/JudgmentUnitSelecter";
import { SelectOptionData } from "../Common/Utils";

const { Option } = Select;

interface DocumentRegistItemData {
  folderName: string;
  uploadDatetime: string;
  // fy: string;
  // examinationCode: string;
  // examinationName: string;
  // examinationDate: Date;
  // applicantCount: number;
  filesCount: number;
  size: number;
}
interface StartImportRequestData {
  folderName: string;
  importMmethod: string;
  filesCount: number;
  fy: string;
  entranceExam1Id?: string;
  entranceExam2Id?: string;
  entranceExam3Id?: string;
  fyJudgementUnitId?: string;
  documentId: string;
  fySubjectId?: string;
}
interface StateType {
  defaultFy: string;
  importType: string;
  fileNameType: string;
  entranceExam1: string;
  entranceExam2: string;
  entranceExam3: string;
  documentOptions: SelectOptionData[];
  subjectOptions: SelectOptionData[];
  judgmentUnit: string;
  document: string;
  subject: string;
  registDocumentItem: DocumentRegistItemData | null;
  datas: DocumentRegistItemData[];
  selectedRowKeys: React.Key[];
}

export class DocumentRegistPage extends React.Component<any, StateType> {
  static contextType = AuthContext;
  private _page: React.RefObject<Page>;
  private _form: React.RefObject<any>;

  constructor(props, context) {
    super(props, context);
    this._page = React.createRef<Page>();
    this._form = React.createRef();
    this.state = {
      defaultFy: context.user.currentYear.toString(),
      importType: "1",
      fileNameType: "取込元ユニークキー",
      entranceExam1: "",
      entranceExam2: "",
      entranceExam3: "",
      documentOptions: [],
      subjectOptions: [],
      judgmentUnit: "",
      document: "",
      subject: "",
      registDocumentItem: null,
      datas: [],
      selectedRowKeys: [],
    };
  }

  // async componentDidMount() {
  //   // this._page.current?.setState({ isPageLoading: true });
  //   // await new Promise((f) => setTimeout(f, 1000));
  // }

  onImportTypeChange = (e) => {
    if (e.target.value === "1") {
      this.setState({
        importType: "1",
        fileNameType: "取込元ユニークキー",
      });
    } else {
      this.setState({
        importType: "2",
        fileNameType: "受験番号",
      });
    }
    this.setState({
      entranceExam1: "",
      entranceExam2: "",
      entranceExam3: "",
      documentOptions: [],
      subjectOptions: [],
      judgmentUnit: "",
      document: "",
      subject: "",
    });
    this._form.current.setFieldsValue({
      entranceExam1: { value: "" },
      entranceExam2: { value: "" },
      entranceExam3: { value: "" },
      judgmentUnit: "",
      document: "",
      subject: "",
    });
  };

  onFyChange = (newValue) => {
    this.setState({
      defaultFy: newValue.value,
    });
  };

  onEntranceExam1Changed = async (item: any) => {
    // console.log("onEntranceExam1Changed:", item);
    this.setState(
      {
        entranceExam1: item ? item.value : "",
      },
      () => this.getDocumentTypes("1")
    );
  };
  onEntranceExam2Changed = async (item: any) => {
    // console.log("Success:", record);
    this.setState(
      {
        entranceExam2: item ? item.value : "",
      },
      () => this.getDocumentTypes("1")
    );
  };
  onEntranceExam3Changed = async (item: any) => {
    // console.log("Success:", record);
    this.setState(
      {
        entranceExam3: item ? item.value : "",
      },
      () => this.getDocumentTypes("1")
    );
  };

  onJudgmentUnitSelected = async (record: any) => {
    // console.log("Success:", record);
    if (record) {
      this.setState({ judgmentUnit: record.fyJudgementUnitId }, () =>
        this.getDocumentTypes("2")
      );
    } else {
      this.setState({ judgmentUnit: "" }, () => this.getDocumentTypes("2"));
    }
  };

  getDocumentTypes = async (type: string) => {
    this.setState({
      documentOptions: [],
      subjectOptions: [],
      document: "",
      subject: "",
    });
    this._form.current.setFieldsValue({
      document: "",
      subject: "",
    });

    let path = `/ApplyDocument/documenttypes`;
    if (type === "1") {
      const eid1 = this.state.entranceExam1;
      if (eid1 === undefined || eid1 == null || eid1 === "") return;
      const eid2 = this.state.entranceExam2;
      const eid3 = this.state.entranceExam3;
      path = path + `?eid1=${eid1}&eid2=${eid2}&eid3=${eid3}`;
    } else {
      const jid = this.state.judgmentUnit;
      if (jid === undefined || jid == null || jid === "") return;
      path = path + `?jid=${jid}`;
    }

    const result = await http<SelectOptionData[]>({
      path: path,
      accessToken: this.context.accessToken,
    });
    if (result.ok && result.body) {
      this.setState({
        documentOptions: result.body,
      });
    } else {
      this.setState({
        documentOptions: [],
      });
    }
  };

  onDocumentChanged = (newValue) => {
    this.setState(
      {
        document: newValue,
      },
      () => this.getSubjects()
    );
  };

  getSubjects = async () => {
    let path = `/ApplyDocument/subjects`;

    const document = this.state.document;
    if (document === undefined || document == null || document === "") return;

    if (document.startsWith("2_") || document.startsWith("3_")) {
      const importType = this.state.importType;
      if (importType === "1") {
        const eid1 = this.state.entranceExam1;
        if (eid1 === undefined || eid1 == null || eid1 === "") return;
        const eid2 = this.state.entranceExam2;
        const eid3 = this.state.entranceExam3;
        path = path + `?eid1=${eid1}&eid2=${eid2}&eid3=${eid3}&did=${document}`;
      } else {
        const jid = this.state.judgmentUnit;
        if (jid === undefined || jid == null || jid === "") return;
        path = path + `?jid=${jid}&did=${document}`;
      }

      const result = await http<SelectOptionData[]>({
        path: path,
        accessToken: this.context.accessToken,
      });
      if (result.ok && result.body) {
        this.setState({
          subjectOptions: result.body,
        });
      } else {
        this.setState({
          subjectOptions: [],
        });
      }
    } else {
      this.setState({ subjectOptions: [], subject: "" });
    }
  };

  onSubjectChanged = (newValue) => {
    this.setState({
      subject: newValue,
    });
  };

  columns = [
    {
      title: <div className="table-title">アップロードフォルダ名</div>,
      dataIndex: "folderName",
      key: "folderName",
      width: "55%",
    },
    {
      title: <div className="table-title">ファイル数</div>,
      dataIndex: "filesCount",
      key: "filesCount",
      width: "10%",
    },
    {
      title: <div className="table-title">サイズ</div>,
      key: "size",
      render: (value: any, item: DocumentRegistItemData, index: number) => {
        const folderSize = (
          item.size && item.size != null
            ? Math.round((item.size / 1024 / 1024) * 100) / 100
            : 0
        ).toLocaleString();
        return `${folderSize} MB`;
      },
      width: "10%",
    },
    {
      title: <div className="table-title">アップロード日時</div>,
      dataIndex: "uploadDatetime",
      key: "uploadDatetime",
      width: "20%",
    },
  ];

  loadData = async () => {
    try {
      this._page.current?.setState({ isPageLoading: true });
      const result = await http<DocumentRegistItemData[]>({
        path: "/ApplyDocument/listfolders",
        accessToken: this.context.accessToken,
      });

      if (result.ok && result.body) {
        this.setState({
          datas: result.body,
          // datas: this.data,
        });
      }
      this._page.current?.setState({ isPageLoading: false });
    } catch (error) {
      console.log(error);
      this._page.current?.setState({ isPageLoading: false });
    }
  };

  onCall = async () => {
    if (this.state.registDocumentItem) {
      try {
        if (this.state.importType === "1") {
          const validateFields = [
            "importType",
            "fy",
            "entranceExam1",
            "document",
          ];
          if (this.state.subjectOptions.length > 0) {
            validateFields.push("subject");
          }
          await this._form.current.validateFields(validateFields);
        } else {
          const validateFields = [
            "importType",
            "fy",
            "judgmentUnit",
            "document",
          ];
          if (this.state.subjectOptions.length > 0) {
            validateFields.push("subject");
          }
          await this._form.current.validateFields(validateFields);
        }
      } catch (errorInfo) {
        console.log("Failed:", errorInfo);
        return;
      }

      try {
        this._page.current?.setState({ isPageLoading: true });
        let requestData: StartImportRequestData;
        if (this.state.importType === "1") {
          requestData = {
            folderName: this.state.registDocumentItem.folderName,
            filesCount: this.state.registDocumentItem.filesCount,
            importMmethod: this.state.importType,
            fy: this.state.defaultFy,
            documentId: this.state.document,
            entranceExam1Id: this.state.entranceExam1,
            entranceExam2Id: this.state.entranceExam2
              ? this.state.entranceExam2
              : undefined,
            entranceExam3Id: this.state.entranceExam3
              ? this.state.entranceExam3
              : undefined,
            fySubjectId: this.state.subject ? this.state.subject : undefined,
          };
        } else {
          requestData = {
            folderName: this.state.registDocumentItem.folderName,
            filesCount: this.state.registDocumentItem.filesCount,
            importMmethod: this.state.importType,
            fy: this.state.defaultFy,
            documentId: this.state.document,
            fyJudgementUnitId: this.state.judgmentUnit
              ? this.state.judgmentUnit
              : undefined,
            fySubjectId: this.state.subject ? this.state.subject : undefined,
          };
        }

        const result = await http<undefined, StartImportRequestData>({
          path: "/ApplyDocument/start",
          method: "post",
          body: requestData,
          accessToken: this.context.accessToken,
          noResponsebody: true,
        });
        this._page.current?.setState({ isPageLoading: false });
        if (result.ok) {
          message.info(Messages["MSG-012"]);
          await this.loadData();
        } else {
          Modal.error({
            content: Messages["ERR-028"],
          });
        }
      } catch (error) {
        console.log(error);
        Modal.error({
          content: Messages["ERR-028"],
        });
        this._page.current?.setState({ isPageLoading: false });
      }
    } else {
      Modal.error({
        content: Messages["ERR-029"],
      });
    }
  };

  render(): React.ReactNode {
    const { selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      columnTitle: <div className="table-title">選択</div>,
      fixed: false,
      onSelect: (record: DocumentRegistItemData, selected: boolean) => {
        if (selected) {
          const keys: React.Key[] = [];
          keys.push(record.folderName);
          this.setState({
            selectedRowKeys: keys,
            registDocumentItem: record,
          });
        } else {
          this.setState({
            selectedRowKeys: [],
            registDocumentItem: null,
          });
        }
      },
    };

    return (
      <Page ref={this._page} title="出願時提出書類登録">
        <div className="data_content">
          <br />
          <Form
            colon={false}
            ref={this._form}
            layout="horizontal"
            labelAlign="left"
            name="documentForm"
            initialValues={{
              fy: { value: this.state.defaultFy },
              importType: this.state.importType,
            }}
          >
            <Row>
              <Col span={10}>
                <Form.Item
                  labelCol={{ span: 6 }}
                  label="取込方法"
                  name="importType"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Radio.Group onChange={this.onImportTypeChange}>
                    <Space>
                      <Radio value="1">実志願者ユニークキー</Radio>
                      <Radio value="2">受験番号</Radio>
                    </Space>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col span={14}>
                <div
                  style={{
                    fontWeight: "bold",
                    display: this.state.fileNameType === "" ? "none" : "",
                  }}
                >
                  ※ファイル名は
                  <span
                    style={{
                      textDecoration: "underline",
                      marginLeft: "2px",
                      marginRight: "2px",
                    }}
                  >
                    {this.state.fileNameType}
                  </span>
                  となります。
                </div>
              </Col>
            </Row>
            <Row>
              <Col span={10}>
                <h3>＜取込元＞</h3>
              </Col>
              <Col span={14}>
                <Form.Item>
                  <Button
                    type="primary"
                    size="middle"
                    onClick={(e) => this.loadData()}
                  >
                    アップロード済フォルダ検索
                  </Button>
                </Form.Item>
              </Col>
            </Row>
            <Row></Row>
            <Row>
              <Col span={18}>
                <h4>アップロード済フォルダ</h4>
                <Table
                  rowKey={(record) => record.folderName}
                  bordered
                  rowSelection={{
                    type: "checkbox",
                    ...rowSelection,
                  }}
                  pagination={false}
                  columns={this.columns}
                  dataSource={this.state.datas}
                  scroll={{ y: "250px" }}
                />
              </Col>
            </Row>
            <Row></Row>
            <Row></Row>
            <Row>
              <Col span={4}>
                <h3>＜取込先＞</h3>
              </Col>
            </Row>
            <Row>
              <Col span={6}>
                <Form.Item
                  labelCol={{ span: 6 }}
                  label="入試年度"
                  name="fy"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <CommonMasterSelect
                    allowClear={false}
                    masterType={31}
                    onChange={this.onFyChange}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row
              style={{
                display: this.state.importType === "1" ? "" : "none",
              }}
            >
              <Col span={6}>
                <Form.Item
                  labelCol={{ span: 6 }}
                  label="入試制度1"
                  name="entranceExam1"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <CommonMasterSelect
                    masterType={25}
                    width={160}
                    fy={this.state.defaultFy}
                    onChange={this.onEntranceExam1Changed}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label="入試制度2"
                  name="entranceExam2"
                  labelCol={{ span: 6 }}
                >
                  <CommonMasterSelect
                    masterType={26}
                    width={160}
                    fy={this.state.defaultFy}
                    fid={this.state.entranceExam1}
                    onChange={this.onEntranceExam2Changed}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  label="入試制度3"
                  name="entranceExam3"
                  labelCol={{ span: 6 }}
                >
                  <CommonMasterSelect
                    masterType={27}
                    width={160}
                    fy={this.state.defaultFy}
                    fid={this.state.entranceExam2}
                    onChange={this.onEntranceExam3Changed}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row
              style={{
                display: this.state.importType === "2" ? "" : "none",
              }}
            >
              <Col span={18}>
                <Form.Item
                  labelCol={{ span: 2 }}
                  label="判定単位"
                  name="judgmentUnit"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <JudgmentUnitSelecter
                    width={500}
                    defaultFy={this.state.defaultFy}
                    onDataSelect={this.onJudgmentUnitSelected}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={6}>
                <Form.Item
                  labelCol={{ span: 6 }}
                  label="提出種類"
                  name="document"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select
                    allowClear={false}
                    onChange={this.onDocumentChanged}
                    style={{ width: 200 }}
                  >
                    {this.state.documentOptions.length > 0 &&
                      this.state.documentOptions.map((data: any) => (
                        <Option key={data.id} value={data.id}>
                          {data.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col
                span={6}
                style={{
                  display: this.state.subjectOptions.length > 0 ? "" : "none",
                }}
              >
                <Form.Item
                  labelCol={{ span: 6 }}
                  label="試験科目"
                  name="subject"
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select
                    allowClear={false}
                    onChange={this.onSubjectChanged}
                    style={{ width: 200 }}
                  >
                    {this.state.subjectOptions.length > 0 &&
                      this.state.subjectOptions.map((data: any) => (
                        <Option key={data.id} value={data.id}>
                          {data.name}
                        </Option>
                      ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ marginTop: "30px" }}>
              <Col span={10}></Col>
              <Col span={14}>
                <Form.Item>
                  <Popconfirm
                    title="提出書類の取込処理を実行してもよろしいですか？"
                    okText="はい"
                    cancelText="いいえ"
                    onConfirm={() => this.onCall()}
                  >
                    <AuthorityButton type="primary" size="middle">
                      取込処理実行
                    </AuthorityButton>
                  </Popconfirm>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Page>
    );
  }
}
